/* @flow */

import {unexpectedCase} from 'nutshell-core/reducer-utils';
import {REHYDRATE} from 'redux-persist';
import {ActionTypes, type AttributionModalAction} from './attribution-modal-actions';

export type AttributionModalState = {
    isOpen: boolean,
};

export const defaultAttributionModalState = {
    isOpen: false,
};

export const attributionModalReducer = (
    state: AttributionModalState = defaultAttributionModalState,
    action: AttributionModalAction
): AttributionModalState => {
    switch (action.type) {
        case ActionTypes.ATTRIBUTION_MODAL_OPENED:
            return {
                ...state,
                isOpen: true,
            };
        case ActionTypes.ATTRIBUTION_MODAL_CLOSED:
            return defaultAttributionModalState;
        case REHYDRATE: {
            return state;
        }
        default:
            unexpectedCase(action.type);

            return state;
    }
};
